import { DriverNotificationRouteUpdated } from "../../../ducks/app/notifications/types";
import { useTranslation } from "react-i18next";

const InAppRouteUpdatedNotification = ({
  notification,
}: {
  notification: DriverNotificationRouteUpdated;
}) => {
  const { t } = useTranslation("notifications");

  return (
    <div>
      <div className={"mb-2"}>{t("notificationTextRouteChanged")}</div>
      {notification.data.changes.map((change, i) => {
        let text = "";
        const translationProps = "data" in change ? change.data : {};
        switch (change.type) {
          case "STOPS_REORDERED":
            text = t("routeUpdated.stopsReordered");
            break;
          case "STOPS_ADDED":
            text = t("routeUpdated.stopsAdded");
            break;
          case "STOPS_REMOVED":
            text = t("routeUpdated.stopsRemoved");
            break;
          case "STOPS_UPDATED":
            switch (change.data.property) {
              case "OPENING_DATE":
                text = t(
                  "routeUpdated.stopUpdated_openingDateChanged",
                  translationProps
                );
                break;
              case "OPENING_TIME":
                text = t(
                  "routeUpdated.stopUpdated_openingTimeChanged",
                  translationProps
                );
                break;
              case "ADDRESS":
                text = t(
                  "routeUpdated.stopUpdated_addressChanged",
                  translationProps
                );
                break;
              case "DIMENSION_LOADMETERS":
                text = t(
                  "routeUpdated.stopUpdated_loadmetersChanged",
                  translationProps
                );
                break;
              case "DIMENSION_VOLUME":
                text = t(
                  "routeUpdated.stopUpdated_volumeChanged",
                  translationProps
                );
                break;
              case "DIMENSION_WEIGHT":
                text = t(
                  "routeUpdated.stopUpdated_weightChanged",
                  translationProps
                );
                break;
              case "DIMENSION_HEIGHT":
                text = t(
                  "routeUpdated.stopUpdated_heightChanged",
                  translationProps
                );
                break;
              case "DIMENSION_WIDTH":
                text = t(
                  "routeUpdated.stopUpdated_widthChanged",
                  translationProps
                );
                break;
              case "DIMENSION_LENGTH":
                text = t(
                  "routeUpdated.stopUpdated_lengthChanged",
                  translationProps
                );
                break;
              default:
                console.error("Unknown property type", change.data.property);
                text = "Couldn't resolve notification type";
                break;
            }
            break;
          default:
            console.error("Unknown change", change);
        }

        return <div key={i}>• {text}</div>;
      })}
    </div>
  );
};

export default InAppRouteUpdatedNotification;
